/* import __COLOCATED_TEMPLATE__ from './card-white-us-back.hbs'; */
import Component from '@glimmer/component';
import { formatPAN } from '@banking/ui/utils/format';
import { assertNonNullable } from '@banking/ui/utils/assert';
export default class CardWhiteUsBack extends Component {
  get fullPan() {
    return formatPAN(this.args.cardData.fullPan);
  }
  get expirationDate() {
    return new Date(assertNonNullable(this.args.cardData.expiration?.year), assertNonNullable(this.args.cardData.expiration?.monthOfYear) - 1);
  }
}